const inTest = ['localhost', 'dev-web.gqj006.com', 'test-web.gqj006.com'].includes(location.hostname)
const isHTTPS = /^https/i.test(location.href)
const ws = {
	protocol: isHTTPS ? 'wss' : 'wss',
	instance: null,
	timer: null,
	tryCount: 10,
	heartTimer: null
};
export default {
	data() {
		return {
			wsUrl: inTest ? `${ws.protocol}://dev-ws.gqj006.com` : `${ws.protocol}://ws.gqj.tv`,
			playerUrl: inTest ? "//dev-player.gqj006.com/" : "//player.gqj.tv/",
			commonChatroomNotice: '任何群、广告均为诈骗，违规者封号处理', // '为营造绿色的直播环境，本站正在进行严格的整改，任何违规的行为一律进行封号处理，力求为广大网友带来纯净的观赛体验，主播即将回归，敬请期待！'
		}
	},
	methods: {
		setCookie(name, value) {
			document.cookie = name + "=" + value + ";path=/";
		},
		getCookie(name) {
			var arr = document.cookie.split("; ");
			for (var i = 0; i < arr.length; i++) {
				var arr2 = arr[i].split("=");
				if (arr2[0] == name) {
					return arr2[1];
				}
			}
			return "";
		},
		connectSocket(task_id, msgCallback) {
			if (ws.instance) {
				return;
			}
			ws.instance = new WebSocket(this.wsUrl);
			ws.instance.onmessage = (event) => {
				const data = JSON.parse(event.data);
				this.$bus.$emit("ws.message", data);
				typeof msgCallback == 'function' && msgCallback(data)
				heartbeat()
			};
			ws.instance.onopen = (event) => {
				task_id && ws.instance.send(JSON.stringify({
					type: 'init',
					task_id
				}))
				heartbeat()
			};
			ws.instance.onerror = (event) => {
				console.warn("ws.error", event);
			};
			ws.instance.onclose = (event) => {
				ws.instance = null;
				ws.timer && clearTimeout(ws.timer);
				if (--ws.tryCount) {
					ws.timer = setTimeout(() => {
						this.connectSocket(task_id, msgCallback);
					}, 5000);
				}
			};

			function heartbeat() {
				ws.heartTimer && clearTimeout(ws.heartTimer)
				ws.heartTimer = setTimeout(() => {
					const data = {
						type: 'ping'
					}
					task_id && (data.task_id = task_id);
					ws.instance.send(JSON.stringify(data));
					heartbeat()
				}, 20000)
			}
		},
		async closeWs() {
			if (ws.instance) {
				ws.tryCount = 0
				await ws.instance.close()
			}
		},
		onSwiperCoverError(e) {
			e.target.src = require('@/assets/images/swiper_cover_default.png')
		},
		onNewsCoverError(e) {
			e.target.src = require('@/assets/images/news_cover_default.png')
		},
		onAvatarError(e) {
			e.target.src = require('@/assets/images/default_avatar.png')
		},
		onLolTeamLogoError(e) {
			e.target.src = require('@/assets/images/gaming/lol.png')
		},
		onLolSkillError(e) {
			e.target.src = require('@/assets/images/gaming/prop-default.png')
		},
		onCsgoTeamLogoError(e) {
			e.target.src = require('@/assets/images/gaming/csgo.png')
		},
		onDotaTeamLogoError(e) {
			e.target.src = require('@/assets/images/gaming/dota.png')
		},
		onKogTeamLogoError(e) {
			e.target.src = require('@/assets/images/gaming/kog.png')
		},
		pickImgError(e) {
			e.target.src = require('@/assets/images/gaming/member-pick.png')
		},
		banImgError(e) {
			e.target.src = require('@/assets/images/gaming/member-ban.png')
		},
		onKogSkillError(e) {
			e.target.src = require('@/assets/images/gaming/kog-prop-default.png')
		},
		onHeroImgError(e) {
			e.target.src = require('@/assets/images/gaming/member-pick.png')
		},
		playerImgError(e) {
			e.target.src = require('@/assets/images/gaming/player-avatar-default.png')
		}
	}
}
